import { Usp } from "@omni/types/components/product/productPage/usps.type";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type UspContextValue = {
    usp: Usp;
};

type UspContextProviderProps = {
    usp: Usp;
    children: ReactNode;
};

export const UspContext = createContext<UspContextValue | undefined>(undefined);

export const UspContextProvider = ({
    usp,
    children
}: UspContextProviderProps) => {
    return (
        <UspContext
            value={{
                usp: usp
            }}
        >
            {children}
        </UspContext>
    );
};

export const useUspContext = () => {
    const context = use<UspContextValue | undefined>(UspContext);

    if (!isDefined(context)) {
        throw new Error(`${UspContext.displayName} is undefined.`);
    }

    return context;
};
